import { Injectable, EventEmitter  } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeFooterComponentFunction = new EventEmitter();
  invokeHeaderComponentFunction = new EventEmitter();
  invokeExampleComponentFunction = new EventEmitter();
  subsVar: Subscription;

  constructor() { }

  activarFooter(callFunction: any) {
    console.log('por aca paso', callFunction);
    this.invokeFooterComponentFunction.emit(callFunction);
  }

  manageHeader(callFunction: any) {
    console.log('llamada header', callFunction);
    this.invokeHeaderComponentFunction.emit(callFunction);
  }

  examplefunc(callFunction: any) {
    console.log('llamada exmple', callFunction);
    this.invokeExampleComponentFunction.emit(callFunction);
  }


}
